<template>
  <section class="main-panel__content">
    <slot></slot>
    <div class="main-panel__sidebar">
      <NavBar></NavBar>
    </div>
  </section>
</template>
<script>
import NavBar from './NavBar';

export default {
  name: 'App',
  components: { NavBar },
  computed: {},
  methods: {},
  mounted() {
  },
};
</script>
